import React, { useEffect, useState } from "react";
import Navbar from "../../../components/Navbar/Navbar";
import tracklimologo from "../../../assets/tracklimo.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAdd,
  faPencil,
  faPhoneAlt,
  faPhoneFlip,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import {
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faBackward,
  faEnvelope,
  faKey,
  faLock,
  faPhone,
  faTrash,
  faUser,
} from "@fortawesome/fontawesome-free-solid";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../../components/Modal";
import { setProfileBoxAction } from "../../../redux/auth/auth-slice";
import { IoIosSearch } from "react-icons/io";
import Footer from "../../../components/footer/Footer";
import {
  setEditDriver,
  setSearchDriver,
} from "../../../redux/driver/driver-slice";
import { toast } from "react-toastify";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import axios from "axios";

const DriverManagement = () => {
  const dispatch = useDispatch();
  const { user, token } = useSelector((state) => state.auth);
  const { allDrivers, editDriver, searchDriver, isLoading } = useSelector(
    (state) => state.driver
  );
  console.log(user, "affiliate user");
  const [driveraddModal, setdriveraddModal] = useState(false);
  const [driverEditModal, setDriverEditModal] = useState(false);
  const [resetPassword, setresetPassword] = useState();
  const [deleteDriver, setdeleteDriver] = useState(false);
  const [driverCreateInput, setdriverCreateInput] = useState({
    name: "",
    countryCode: "",
    contactNumber: "",
    password: "",
    email: "",
    carPlateNo: "",
    carLicenseNo: "",
  });
  const [driverPage, setdriverPage] = useState(1);

  const [totalDriversCnt, settotalDriversCount] = useState();

  const totalDriversCount = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/drivers/totalDriversCount`,
        {
          headers: {
            Authorization: token,
          },
          withCredentials: true,
        }
      );

      settotalDriversCount(response.data.count);
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.msg || "Something went wrong");
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      totalDriversCount();
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [token]);

  useEffect(() => {
    dispatch({
      type: "GET_ALL_DRIVERS",
      payload: { token, page: driverPage },
    });
  }, [driverPage, token]);

  const createDriver = (e) => {
    e.preventDefault();
    if (
      driverCreateInput.name.length === 0 ||
      driverCreateInput.countryCode.length === 0 ||
      driverCreateInput.contactNumber.length === 0 ||
      driverCreateInput.password.length === 0
    ) {
      toast.warning("It seems you haven't filled all the required fields");
      return;
    }

    if (driverCreateInput.name === "") {
      toast.warning("Please Enter Driver Name");
    } else if (driverCreateInput.countryCode === "") {
      toast.warning("Please Enter Country Code");
    } else if (driverCreateInput.contactNumber === "") {
      toast.warning("Please Enter ContactNumber");
    } else if (driverCreateInput.password === "") {
      toast.warning("Please Enter Password");
    } else if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
        driverCreateInput.email
      ) === false
    ) {
      toast.warning("Please enter a valid email");
      return;

      // The regex.test() method is used to test for a match in a string.
      // The method returns true if it finds a match; otherwise, it returns false.
    } else if (
      driverCreateInput.password.length != 0 &&
      driverCreateInput.password.length < 8
    ) {
      toast.warning("Please enter password of length 8 atleast");
    } else {
      const payload = {
        name: driverCreateInput?.name,
        countryCode: driverCreateInput?.countryCode,
        contactNumber: driverCreateInput?.contactNumber,
        password: driverCreateInput?.password,
        email: driverCreateInput?.email,
        carPlateNo: driverCreateInput?.carPlateNo,
        carLicenseNo: driverCreateInput?.carLicenseNo,
        companyId: user?.companyid,
      };

      console.log(payload);

      dispatch({
        type: "REGISTER_DRIVER",
        payload: {
          body: payload,
          token,
        },
      });
      setdriveraddModal(false);
      setdriverCreateInput({
        name: "",
        countryCode: "",
        contactNumber: "",
        password: "",
        email: "",
        carPlateNo: "",
        carLicenseNo: "",
      });
    }
  };

  const [searchTerm, setSearchTerm] = useState("");
  console.log("searchTerm", searchTerm);
  useEffect(() => {
    if (searchTerm !== "") {
      dispatch({
        type: "SEARCH_DRIVER",
        payload: {
          searchTerm: searchTerm,
          companyId: user?.companyid,
        },
      });
    } else {
      dispatch(
        setSearchDriver({
          searchDriver: [],
        })
      );
    }
  }, [searchTerm]);

  useEffect(() => {
    dispatch(setProfileBoxAction({ profileBoxAction: false }));
  }, []);

  useEffect(() => {
    dispatch({ type: "GET_ALL_DRIVERS", payload: { token, page: driverPage } });
  }, []);

  return (
    <div className="h-screen w-screen fixed">
      {/* header */}
      <Navbar />
      {driveraddModal && (
        <>
          <div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50 z-50 flex justify-center items-center"></div>

          <Modal
            heading="Add Driver"
            cancelOnClick={() => {
              setdriveraddModal(false);
              setdriverCreateInput({
                name: "",
                countryCode: "",
                contactNumber: "",
                password: "",
                email: "",
                carPlateNo: "",
                carLicenseNo: "",
              });
            }}
            label="Save"
            isDriverCreate={true}
            submitOnClick={createDriver}
            driverName={driverCreateInput?.name}
            driverCarPlateNumber={driverCreateInput?.carPlateNo}
            driverCarLicenseNo={driverCreateInput?.carLicenseNo}
            driverEmail={driverCreateInput?.email}
            driverCountryCode={driverCreateInput?.countryCode}
            driverContactNumber={driverCreateInput?.contactNumber}
            driverPassword={driverCreateInput?.password}
            setCountryCodeChange={(e) => {
              console.log("country", e);
              setdriverCreateInput({
                ...driverCreateInput,
                countryCode: e.dial_code,
              });
            }}
            driverNameInput={(e) => {
              setdriverCreateInput({
                ...driverCreateInput,
                name: e.target.value,
              });
            }}
            carPlateInput={(e) => {
              setdriverCreateInput({
                ...driverCreateInput,
                carPlateNo: e.target.value,
              });
            }}
            carLicenseInput={(e) => {
              setdriverCreateInput({
                ...driverCreateInput,
                carLicenseNo: e.target.value,
              });
            }}
            countryCodeInput={(e) => {
              setdriverCreateInput({
                ...driverCreateInput,
                countryCode: e.target.value,
              });
            }}
            contactNumberInput={(e) => {
              setdriverCreateInput({
                ...driverCreateInput,
                contactNumber: e.target.value,
              });
            }}
            driverEmailInput={(e) => {
              setdriverCreateInput({
                ...driverCreateInput,
                email: e.target.value,
              });
            }}
            driverPasswordInput={(e) => {
              const length = e.target.value?.length;
              if (e.target.value[length - 1] === " ") {
                // toast.warn("No space allowed in password");
                return;
              }
              setdriverCreateInput({
                ...driverCreateInput,
                password: e.target.value,
              });
            }}
          />
        </>
      )}

      {driverEditModal && (
        <>
          <div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50 z-50 flex justify-center items-center"></div>
          <Modal
            isDriverModalEdit={true}
            heading="Edit Driver"
            label="Edit"
            // setEditCountryCodeChange={(e)=>{
            //   console.log("country",e)

            // }}
            cancelOnClick={() => {
              setDriverEditModal(false);
            }}
            submitOnClick={() => {
              dispatch({
                type: "EDIT_DRIVER",
                payload: {
                  driverId: editDriver?._id,
                  body: editDriver,
                },
              });
              setDriverEditModal(false);
            }}
          />
        </>
      )}

      <div
        className="pt-2 pb-5 h-screen bg-black"
        onClick={() => {
          dispatch(setProfileBoxAction({ profileBoxAction: false }));
        }}
      >
        {/* screen below sm */}
        <div className="sm:hidden">
          <div className="flex justify-between space-x-10 mt-10 md:mt-0 mx-5 md:mx-16 xl:mx-32 items-center">
            <div className="w-full xs:w-1/2 3xl:pl-12 xl:pr-5 3xl:pr-20">
              <div className="relative w-full 3xl:w-auto ">
                <input
                  className="w-full px-10 rounded-full bg-slate-700/30 py-1.5 border border-slate-700/70 focus:border-slate-700/60 focus:outline-none text-white"
                  placeholder="Search Contacts"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                  }}
                />
                <IoIosSearch className="absolute top-3 left-3 text-white" />
              </div>
            </div>

            <div className="w-44 xs:w-auto text-center">
              <div
                onClick={() => {
                  setdriveraddModal(true);
                }}
                className="flex justify-center bg-[#144EE3] rounded-full border border-[#144EE3] text-sm px-4 py-2 shadow-sm shadow-blue-700 text-white space-x-1 font-semibold cursor-pointer"
              >
                Add Driver
              </div>
            </div>
          </div>

          <div className="sm:text-lg md:text-xl 2md:text-2xl font-semibold text-white  px-5 mt-3">
            All Drivers Details
          </div>
        </div>

        {/* screen above sm */}
        <div className="hidden sm:block mt-6">
          <div className="flex mt-10 md:mt-0 mx-10 md:mx-16 xl:mx-32 items-center">
            <div className="flex items-center space-x-2 w-1/3 ">
              <div className="sm:text-lg md:text-xl 2md:text-2xl font-semibold text-white">
                All Drivers Details
              </div>
            </div>

            <div className="w-3/5 3xl:pl-12 xl:pr-5 3xl:pr-20">
              <div className="relative w-full 3xl:w-auto ">
                <input
                  className="w-full px-10 rounded-full bg-slate-700/30 py-1.5 border border-slate-700/70 focus:border-slate-700/60 text-white"
                  placeholder="Search Contacts"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                  }}
                />
                <IoIosSearch className="absolute top-3 left-3 text-white" />
              </div>
            </div>

            <div className="flex justify-end w-1/3">
              <div
                onClick={() => {
                  setdriveraddModal(true);
                }}
                className="flex bg-[#144EE3] rounded-full border border-[#144EE3] text-base px-8 py-1.5 shadow-sm shadow-blue-700 text-white space-x-1 font-semibold cursor-pointer"
              >
                <div>Add Driver</div>
                <div>
                  <FontAwesomeIcon icon={faAdd} className="text-xs" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-end mt-5 mx-36 items-center space-x-3">
          <button
            onClick={() => {
              if (driverPage > 1) {
                setdriverPage(driverPage - 1);
                dispatch({
                  type: "GET_ALL_DRIVERS",
                  payload: { token, page: driverPage },
                });
              }
            }}
          >
            <FontAwesomeIcon
              icon={faArrowAltCircleLeft}
              className={`text-xl ${
                driverPage > 1 ? `text-white` : `text-gray-500 `
              } `}
            />
          </button>
          <div>
            {driverPage} /{" "}
            {totalDriversCnt ? Math.round(totalDriversCnt / 20) : "Loading..."}
          </div>
          <button
            onClick={() => {
              if (driverPage < Math.round(totalDriversCnt / 20)) {
                setdriverPage(driverPage + 1);
                dispatch({
                  type: "GET_ALL_DRIVERS",
                  payload: { token, page: driverPage },
                });
              }
            }}
          >
            <FontAwesomeIcon
              icon={faArrowAltCircleRight}
              className={`text-xl ${
                driverPage < Math.round(totalDriversCnt / 20)
                  ? `text-white`
                  : `text-gray-500 cursor-not-allowed`
              }  `}
            />
          </button>
        </div>
        <div className="w-full py-[0.4px] bg-gradient-to-r from-[#111111] via-[#848484] to-[#111111]  mt-5"></div>

        {/* ****************************************************************************************************** */}
        <div className="xl:px-16 mt-4 overflow-y-auto h-[75vh] md:h-auto scrollbar md:overflow-hidden">
          <div className="md:border-2 md:border-white/30 rounded-lg mx-5 sm:mx-10 md:mx-16 my-2">
            <div className=" md:overflow-y-auto md:h-[75vh] md:scrollbar pb-10 rounded-lg md:bg-[#121010] shadow-md shadow-[#0f0e0e]">
              <div className="w-full hidden md:flex justify-between rounded-t-lg bg-gradient-to-r from-[#000000] from-50% via-[#444444] via-50% to-[#000000] to-50% px-6 xl:px-10 py-2 text-base font-semibold text-white/60">
                <div className="w-[30%]">Name</div>
                <div className="w-[30%]">Contact Number</div>
                <div className="w-[30%]">Email ID</div>
                <div className="w-[10%] text-right pr-6">Action</div>
              </div>
              {isLoading ? (
                <>
                  <div className="loading loading-bars loading-lg absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-slate-600"></div>
                </>
              ) : (
                <>
                  {(searchDriver.length > 0 ? searchDriver : allDrivers)?.map(
                    (singleDriver) => {
                      console.log("singleDriver=======>", singleDriver);
                      return (
                        <div key={singleDriver?._id}>
                          <DriverItem
                            editDriverOnClick={() => {
                              setDriverEditModal(singleDriver?._id);
                              dispatch(
                                setEditDriver({ editDriver: singleDriver })
                              );
                            }}
                            drivername={singleDriver?.name}
                            carPlateNo={singleDriver?.carPlateNo}
                            carLicenseNo={singleDriver?.carLicenseNo}
                            email={singleDriver?.email}
                            contact={
                              singleDriver?.countryCode +
                              " " +
                              singleDriver?.contactNumber
                            }
                            deleteDriverOnClick={() => {
                              setdeleteDriver(singleDriver?._id);
                            }}
                            resetPasswordOnClick={() => {
                              setresetPassword(singleDriver?._id);
                            }}
                          />
                          {singleDriver?._id === deleteDriver && (
                            <>
                              <div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50 z-20 flex justify-center items-center"></div>
                              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-30 px-12 xl:px-16 py-10 bg-gradient-to-b from-black to-neutral-800 rounded-xl text-center shadow border-2 border-white/40">
                                <div className="flex justify-center mb-5">
                                  <div className="relative bg-zinc-800 w-14 h-14 rounded-full">
                                    <FontAwesomeIcon
                                      icon={faTrashCan}
                                      className="absolute top-3.5 left-[18px] w-5 h-7 text-white"
                                    />
                                  </div>
                                </div>
                                <div className="flex justify-center space-x-2 text-white text-xl sm:text-xl md:text-2xl font-semibold">
                                  Are you sure you want to delete this driver?
                                </div>
                                <div className="flex space-x-6 justify-center text-white mt-9">
                                  <button
                                    className="px-4 sm:px-7 py-1.5 sm:py-2 bg-[#181E29] border border-gray-700 text-lg font-medium text-gray-100 hover:bg-[#161a22] rounded-md"
                                    onClick={() => {
                                      setdeleteDriver("");
                                    }}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    className="flex items-center space-x-2 px-4 sm:px-7 py-1.5 sm:py-2 bg-red-600 border text-white border-red-700 text-lg font-medium rounded-lg hover:bg-red-500 hover:text-white"
                                    onClick={() => {
                                      dispatch({
                                        type: "DELETE_DRIVER",
                                        payload: {
                                          token,
                                          id: singleDriver?._id,
                                        },
                                      });
                                      setdeleteDriver("");
                                    }}
                                  >
                                    <FontAwesomeIcon
                                      icon={faTrashCan}
                                      className="w-3.5 h-6"
                                    />
                                    <h2>Delete</h2>
                                  </button>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      );
                    }
                  )}
                </>
              )}
            </div>
          </div>
          <div className="px-16">
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriverManagement;

export const DriverItem = ({
  drivername,
  contact,
  email,
  resetPasswordOnClick,
  editDriverOnClick,
  deleteDriverOnClick,
}) => {
  const dispatch = useDispatch();
  return (
    <>
      <div className="md:hidden">
        <div
          id="grad"
          className="flex items-center space-x-2 xl:space-x-0 justify-between px-6 xl:px-10 py-3 text-white/70 mt-2 rounded-xl border-2 border-gray-500"
          onClick={() => {
            dispatch(setProfileBoxAction({ profileBoxAction: false }));
          }}
        >
          <div className="space-y-1.5">
            <div className="flex items-center space-x-3 w-full truncate text-base font-semibold uppercase text-white/90">
              <FontAwesomeIcon icon={faUser} className="text-white" />
              <h2 className="w-40 truncate">{drivername}</h2>
            </div>
            <div className="flex items-center space-x-3 w-full truncate text-sm font-normal text-white/90">
              <FontAwesomeIcon icon={faPhone} />
              <h2>{contact}</h2>
            </div>
            <div className="flex items-center space-x-3 text-sm font-normal text-white/90 pr-5 xl:pr-0">
              <FontAwesomeIcon icon={faEnvelope} />
              <h2 className="w-48 truncate">{email}</h2>
            </div>
          </div>
          <div className="w-[10%] space-y-2 flex justify-end">
            <div className="flex items-center space-x-2">
              {/* <div
              onClick={resetPasswordOnClick}
              data-tooltip-id="my-tooltip-1"
              className="bg-slate-800 border border-slate-600 w-10 h-10 rounded-full text-center py-1.5 cursor-pointer"
            >
              <FontAwesomeIcon icon={faLock} />
            </div> */}

              <div>
                <div
                  onClick={editDriverOnClick}
                  className="bg-slate-800 border border-slate-600 w-10 h-10 md:w-8 md:h-8 2md:w-10 2md:h-10 rounded-full text-center py-1.5 md:py-0.5 2md:py-1.5 cursor-pointer"
                  data-tooltip-id="edit-driver"
                  data-tooltip-content="Edit Driver"
                >
                  <FontAwesomeIcon icon={faPencil} />
                </div>
                <Tooltip id="edit-driver" />
              </div>
              <div>
                <div
                  onClick={deleteDriverOnClick}
                  className="bg-slate-800 border border-slate-600 w-10 h-10 md:w-8 md:h-8 2md:w-10 2md:h-10 rounded-full text-center py-1.5 md:py-0.5 2md:py-1.5 cursor-pointer"
                  data-tooltip-id="delete-driver"
                  data-tooltip-content="Delete Driver"
                >
                  <FontAwesomeIcon icon={faTrash} className="text-red-800" />
                </div>
                <Tooltip id="delete-driver" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hidden md:block">
        <div
          className="md:flex items-center space-x-2 xl:space-x-0 justify-between px-6 xl:px-10 py-1.5 text-white/70 mt-2"
          onClick={() => {
            dispatch(setProfileBoxAction({ profileBoxAction: false }));
          }}
        >
          <div className="w-[30%] space-y-2 truncate">{drivername}</div>
          <div className="w-[30%] space-y-2">{contact}</div>
          <div className="w-[30%] space-y-2 truncate pr-5 xl:pr-0">{email}</div>
          <div className="w-[10%] space-y-2 flex justify-end">
            <div className="flex items-center space-x-2">
              {/* <div
              onClick={resetPasswordOnClick}
              data-tooltip-id="my-tooltip-1"
              className="bg-slate-800 border border-slate-600 w-10 h-10 rounded-full text-center py-1.5 cursor-pointer"
            >
              <FontAwesomeIcon icon={faLock} />
            </div> */}

              <div>
                <div
                  onClick={editDriverOnClick}
                  className="bg-slate-800 border border-slate-600 w-10 h-10 md:w-8 md:h-8 2md:w-10 2md:h-10 rounded-full text-center py-1.5 md:py-0.5 2md:py-1.5 cursor-pointer"
                  data-tooltip-id="edit-driver"
                  data-tooltip-content="Edit Driver"
                >
                  <FontAwesomeIcon icon={faPencil} />
                </div>
                <Tooltip id="edit-driver" />
              </div>
              <div>
                <div
                  onClick={deleteDriverOnClick}
                  className="bg-slate-800 border border-slate-600 w-10 h-10 md:w-8 md:h-8 2md:w-10 2md:h-10 rounded-full text-center py-1.5 md:py-0.5 2md:py-1.5 cursor-pointer"
                  data-tooltip-id="delete-driver"
                  data-tooltip-content="Delete Driver"
                >
                  <FontAwesomeIcon icon={faTrash} className="text-red-800" />
                </div>
                <Tooltip id="delete-driver" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hidden md:block w-full bg-grad">
        <div className="mx-0 py-[1px] bg-gradient-to-r from-[#111111] via-[#848484] to-[#111111] my-2"></div>
      </div>
    </>
  );
};
